import icon from "../../ui/imgs/not_found.svg"

function ErrorPage() {
  return (<div className="grid h-screen place-content-center bg-white px-4">
    <div className="text-center">

      <img src={icon} alt="Not Found Icon" />

      <h1 className="mt-6 text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">Uh-oh!</h1>
      
      <p className="mt-4 text-gray-500">Pagina nu a fost gasita.</p>
    </div>
  </div>)
}

export default ErrorPage;